<div class="card-cell-header">
	@if (row.jaren_onvoldoende_class) {
		<div [class]="row.jaren_onvoldoende_class"></div>
	}
	<span class="card-cell-title"> {{ row.key }} </span>
</div>
@switch (variant) {
	@case (DashboardVariant.ACTUEEL) {
		@if (row.actueelRow) {
			@let trendIcon = row.actueelRow.trendIcon;
			<div class="card-cell-score">
				@switch (row.indicator) {
					@case ("exc") {
						<h2 class="card-cell-value">
							{{ row.actueelRow.or_m_nr_score | extendedDecimal: "1.2-2" }}
						</h2>
					}
					@case ("bbs") {
						<h2 class="card-cell-value">
							{{ row.actueelRow.or_m_nr_score | percent: "1.2-2" }}
						</h2>
					}
				}
				@if (toonTrend()) {
					@if (trendIcon) {
						<app-icon [name]="trendIcon.name" [color]="trendIcon.color" size="smallest" [rotate]="trendIcon.rotate ?? 0"></app-icon>
					} @else {
						<div class="empty-trend"></div>
					}
				}
			</div>
			<span [class]="row.verschil_class">
				{{ row.or_m_nr_verschil! > 0 ? "+" : "" }}{{ row.or_m_nr_verschil! | extendedDecimal: "1.2-2" }}
			</span>
		}
	}
	@case (DashboardVariant.HISTORIE) {
		@if (row.linechartProps) {
			<app-linechart [props]="row.linechartProps"></app-linechart>
		}
	}
}
